import { render, staticRenderFns } from "./SelectHolding.vue?vue&type=template&id=2a01c7e1&"
import script from "./SelectHolding.vue?vue&type=script&lang=js&"
export * from "./SelectHolding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports